module.exports = __webpack_public_path__ + "img/dash-VARILUX-PHYSIO_full_white.0239c2c3.png";